<template>
  <base-layout
    :toolbarActive="['xs'].includes($vuetify.breakpoint.name)"
    toolbarClass="v-toolbar--border"
  >
    <template #toolbarBase>
      <div class="display-1 font-weight-bold">Детализация</div>
    </template>

    <v-container v-if="!['xs'].includes($vuetify.breakpoint.name)" fluid pt-0>
      <!-- контент -->
      <detailing-list
        @openDialog="$emit('openDialog', $event)"
      ></detailing-list>
    </v-container>

    <section-not-for-phone
      v-if="['xs'].includes($vuetify.breakpoint.name)"
    ></section-not-for-phone>
  </base-layout>
</template>

<script>
import BaseLayout from "../components/layout/BaseLayout.vue";
import SectionNotForPhone from "../components/common/SectionNotForPhone.vue";
import DetailingList from "../components/detailing/DetailingList.vue";

export default {
  name: "DetailingView",

  components: {
    DetailingList,
    SectionNotForPhone,
    BaseLayout
  },

  data: () => ({}),

  computed: {},

  mounted() {},

  methods: {}
};
</script>
